import { Calendar, CalendarProps, DateLocalizer, dayjsLocalizer, Views } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './BaseCalendar.scss';
import dayjs from 'dayjs';
import { memo, useCallback, useEffect, useState } from 'react';

export type BaseCalendarProps = Omit<CalendarProps, 'localizer'> & {
  localizer?: DateLocalizer;
};

const localizer = dayjsLocalizer(dayjs);

const BaseCalendar = (props: BaseCalendarProps) => {
  const {
    views = {
      month: true,
      week: true,
      day: true,
    },
    formats = {
      dateFormat: 'D',
      weekdayFormat: 'dddd',
      dayFormat: 'dddd',
      timeGutterFormat: 'h A',
    },
    ...restProps
  } = props;

  const [view, setView] = useState(restProps.view || Views.MONTH);
  const [date, setDate] = useState(restProps.date || dayjs().toDate());

  const onView = useCallback((newView: any) => setView(newView), [setView]);
  const onNavigate = useCallback((newDate: any) => setDate(newDate), [setDate]);

  useEffect(() => {
    if (props.view) setView(props.view);
  }, [props.view]);

  useEffect(() => {
    if (props.date) setDate(props.date);
  }, [props.date]);

  return (
    <>
      <Calendar
        localizer={localizer}
        startAccessor='start'
        endAccessor='end'
        style={{ height: '100%' }}
        views={views}
        view={view}
        onView={onView}
        date={date}
        onNavigate={onNavigate}
        formats={formats}
        dayLayoutAlgorithm={view === 'day' ? 'no-overlap' : 'overlap'}
        {...restProps}
      />
    </>
  );
};

export default memo(BaseCalendar);
